import { Tooltip } from '@mui/material';
import { Button } from '@wot/components';
import { IProfessionHobby, IProfessionSkill, IProfessionSubject, ITrialClass, ITutor, ITutorAgreement, ITutorPersonal, ITutorProfessionCategory } from '@wot/typings';
import { useEffect, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { Link, useNavigate, useParams } from 'react-router-dom';
import tutorsApi from '../../api/tutors';
import { LOADING } from '../../assets/animated';
import { BACK_ARROW, DEFAULT_PROFILE_PIC, PRO } from '../../assets/icons';
import BreadCrumb from '../../components/BreadCrumb';
import { useAppSelector } from '../../hooks';
import xhr from '../../utils/fetch';
import { getAttendacePercentage } from '../../utils/functions';
import BookTrial from './Book-trial';
import PurchasePlan from './Purchase Plan';
import TutorAvailability from './TutorCalender';
import { Award, BookOpen, FileCheck, GraduationCap, Laptop, Presentation, Star} from 'lucide-react';
import Footer from '../../components/Landing/Footer';
import { AU, CA, DE, FR, GB, IN, US } from 'country-flag-icons/react/3x2';
import { SEO } from '../../components/SEO';
import { TutorSchema, BreadcrumbSchema } from '../../components/StructuredData';
export default function TutorProfile() {
  const { userData } = useAppSelector((state) => state.userSlice);
  const navigate = useNavigate();
  const [bookTrial, setBookTrial] = useState(false);
  const [purchasePlan, setPurchasePlan] = useState(false);
  const { id } = useParams();
  const [tutor, setTutor] = useState<ITutor>();

  useEffect(() => {
    if (userData && tutor) {
      tutorsApi.addRecentlyViewedTutor({
        tutorId: tutor._id,
        userId: userData._id
      });
    }
  }, [tutor]);

  useEffect(() => {
    if (id) {
      tutorsApi.getTutorById(id).then((data) => setTutor(data));
    }
  }, [id]);

  if (!tutor) {
    return (
      <div className="w-full min-h-[512px] flex items-center justify-center">
        <img src={LOADING} className="w-14 h-14" />
      </div>
    );
  }

  return (
    <>
    <SEO 
      title={`${tutor?.personal?.data?.name || 'Tutor'} - Online Tutor Profile`}
      description={tutor?.personal?.data?.bio?.substring(0, 155) || `Book a session with ${tutor?.personal?.data?.name || 'our expert tutor'}. View profile, qualifications, and availability.`}
      keywords={`tutor, online tutor, ${tutor?.personal?.data?.name || 'tutor'}, ${tutor?.personal?.data?.languagesSpoken?.join(', ') || ''}, online tutoring, 1-on-1 tutoring`}
      url={`/find-tutor/${id}`}
      type="profile"
      publishedTime={tutor?.createdAt}
      modifiedTime={tutor?.updatedAt}
      og={{
        type: 'profile',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: tutor?.personal?.data?.profilePic || '/imgi_1_favicon.png',
          alt: `${tutor?.personal?.data?.name || 'Tutor'} - WorldoTutor Profile`,
          width: 1200,
          height: 630
        },
        profile: {
          firstName: tutor?.personal?.data?.name?.split(' ')[0] || '',
          lastName: tutor?.personal?.data?.name?.split(' ').slice(1).join(' ') || ''
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: tutor?.personal?.data?.profilePic || '/imgi_1_favicon.png',
          alt: `${tutor?.personal?.data?.name || 'Tutor'} - WorldoTutor Profile`
        }
      }}
    />
    
    {/* Structured Data for Tutor Profile */}
    <TutorSchema tutor={tutor} />
    <BreadcrumbSchema 
      items={[
        { name: 'Home', url: '/' },
        { name: 'Find Tutor', url: '/find-tutor' },
        { name: tutor?.personal?.data?.name || 'Tutor', url: `/find-tutor/${id}` }
      ]}
    />
    
  <div className='container mx-auto px-4 '>
        
             <div className="lg:flex lg:items-center lg:gap-3 lg:py-6 hidden">
         <div
            onClick={() => navigate(-1)}
            className="w-8 h-8 flex items-center justify-center border-2 bg-neutralBlue2 rounded-full cursor-pointer"
          >
           <img src={BACK_ARROW} alt="Go Back" className="w-4" />
         </div>
        <BreadCrumb />
          </div>

      {/* Profile of teacher */}
    <div className='grid'>
    <div className=''>
    {/* <NewPersonal personal={tutor.personal.data} agreement={tutor.agreement} tutor={tutor} /> */}
    <PersonalTutProfile personal={tutor.personal.data} agreement={tutor.agreement} tutor={tutor}/>

    </div>
    {/*<div className='lg:col-span-1'>
        <div className="w-full h-full bg-white rounded mb-20 md:mb-0 p-4 flex flex-col items-center gap-4 border">
                <h1 className="text-center text-xl font-semibold">Availability</h1>
                <TutorAvailability profile={tutor} />
                <Link
                               to={`/booktrail`}
                               className="flex w-full max-w-[150px] items-center justify-center" >
                               <Button text="Book a Free Trial" type="primary" onClick={() => { }} />
                             </Link>
              </div>
    </div> */}
</div>

  </div>
  <div className='bg-neutralBlack'>
    <Footer/>
  </div>
    </>
  // {  <div className="bg-[#F5F6F9]">
  //     <div className="w-full md:w-[90%] mx-auto">
  //       <div className="lg:flex lg:items-center lg:gap-3 lg:py-6 hidden">
  //         <div
  //           onClick={() => navigate(-1)}
  //           className="w-8 h-8 flex items-center justify-center border-2 bg-neutralBlue2 rounded-full cursor-pointer"
  //         >
  //           <img src={BACK_ARROW} alt="Go Back" className="w-4" />
  //         </div>
  //         <BreadCrumb />
  //         <div className="w-max ml-auto flex justify-end gap-3">
  //           <Button
  //             text="Book Trial Lesson"
  //             type="s-outlined"
  //             onClick={() => {
  //               if (userData) {
  //                 setBookTrial(true);
  //               } else {
  //                 // @ts-ignore
  //                 localStorage.setItem('prevPath', window.location.pathname);
  //                 navigate('/login');
  //               }
  //             }}
  //             className="bg-white"
  //           />
  //           <Button
  //             text="Purchase Plan"
  //             onClick={() => {
  //               if (userData) {
  //                 setPurchasePlan(true);
  //               } else {
  //                 // @ts-ignore
  //                 localStorage.setItem('prevPath', window.location.pathname);
  //                 navigate('/login');
  //               }
  //             }}
  //           />
  //         </div>
  //       </div>
  //       <div className="w-full flex justify-center gap-5 bg-white py-5 drop-shadow-lg fixed bottom-0 left-0 z-[30] border-t border-neutralBlue1 lg:hidden">
  //         <Button
  //           text="Book Trial Lesson"
  //           type="s-outlined"
  //           onClick={() => {
  //             if (userData) {
  //               setBookTrial(true);
  //             } else {
  //               // @ts-ignore
  //               localStorage.setItem('prevPath', window.location.pathname);
  //               navigate('/login');
  //             }
  //           }}
  //           className="bg-white"
  //         />
  //         <Button
  //           text="Purchase Plan"
  //           onClick={() => {
  //             if (userData) {
  //               setPurchasePlan(true);
  //             } else {
  //               // @ts-ignore
  //               localStorage.setItem('prevPath', window.location.pathname);
  //               navigate('/login');
  //             }
  //           }}
  //         />
  //       </div>
  //       <div className="w-full flex flex-col gap-4 p-2 grow">
  //         <div className="w-full flex lg:flex-row flex-col gap-5">
  //           <div className="lg:w-1/4 w-full h-full flex flex-col gap-7 bg-neutralBlue2 rounded-md p-4">
  //             <div className="w-full flex flex-col gap-7">
  //               <Personal personal={tutor.personal.data} agreement={tutor.agreement} tutor={tutor} />
  //             </div>
  //             <div className="w-full flex flex-col gap-7 py-4 border-t-2">
  //               <Education education={tutor.education.data} />
  //             </div>
  //             <div className="w-full flex flex-col gap-7 py-4 border-t-2">
  //               <Experie nce experience={tutor.experience.data} />
  //             </div>
  //           </div>
  //           <div className="lg:w-3/4 w-full h-full rounded-md gap-5 flex flex-col">
  //             <div className="w-full flex flex-col gap-2 bg-white p-4 rounded">
  //               <h1 className="text-xl font-semibold">What I teach</h1>
  //               {tutor.profession.data.categoryType === 'subject' &&
  //                 tutor.profession.data.categories.map((cate: any, i: any) => <SubjectItem subject={cate} key={i} />)}
  //               {tutor.profession.data.categoryType === 'hobby' &&
  //                 tutor.profession.data.categories.map((cate: any, i: any) => <HobbyItem hobby={cate} key={i} />)}
  //               {tutor.profession.data.categoryType === 'skill' &&
  //                 tutor.profession.data.categories.map((cate: any, i: any) => <SkillItem skill={cate} key={i} />)}
  //             </div>
  //             {tutor?.video?.status === 'complete' && (
  //               <div className="bg-white p-4 rounded-md flex flex-col items-center">
  //                 <span className="text-2xl font-medium text-black py-2">Intro Video</span>
  //                 <div className="w-full h-full px-4 py-2">
  //                   <iframe className="w-full h-[480px]" src={tutor.video.link}></iframe>
  //                 </div>
  //               </div>
  //             )}
  //             <div className="w-full h-full bg-white rounded mb-20 md:mb-0 p-4 flex flex-col items-center gap-4">
  //               <h1 className="text-center text-xl font-semibold">Availability</h1>
  //               <TutorAvailability profile={tutor} />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //     {bookTrial && <BookTrial tutor={tutor} setBookTrial={setBookTrial} />}
  //     {purchasePlan && <PurchasePlan tutor={tutor} setPurchasePlan={setPurchasePlan} />}
  //   </div>}
  );
}

function Personal({ personal, agreement, tutor }: { personal: ITutorPersonal, agreement: ITutorAgreement | undefined, tutor: ITutor }) {
  const [studentsCount, setStudentsCount] = useState(0);
  const [totalSessions, setTotalSessions] = useState<ITrialClass[]>([]);

  useEffect(() => {
    if (tutor) {
      xhr({
        url: `/t/${tutor._id}/stats/students-count`,
        method: "GET"
      }).then(res => setStudentsCount(res.data.count || 0))
        .catch(err => err)
    }
  }, [tutor]);

  // Total Sessions
  useEffect(() => {
    if (tutor?._id) {
      xhr({
        url: `/t/${tutor?._id}/sessions`,
        method: 'GET',
        params: {
          type: 'plan',
          status: 'completed'
        }
      })
        .then((res) => {
          if (res.status === 'OK') {
            setTotalSessions(res.data);
          }
        })
        .catch(() => { });
    }
  }, [tutor]);


  return (
    <>
      <div className="w-full flex flex-col gap-2 bg-neutralBlue2">
        <div className="flex justify-end">
          {agreement?.level === 'premium' ? (
            <Tooltip title="Premium Tutor" arrow>
              <img src={PRO} alt="Pro badge" className="h-7 w-7" />
            </Tooltip>
          ) : (
            <div className="h-7 w-7" />
          )}
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center">
            <img
              src={personal?.profilePic === '' ? DEFAULT_PROFILE_PIC : personal?.profilePic}
              alt="profile pic"
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          <p className="text-base font-medium">{personal.name}</p>
        </div>

        <div className="flex justify-center items-center divide-x">
          <div className="flex flex-col items-center px-1 text-center">
            <span className="text-sm font-medium">{studentsCount}</span>
            <span className="text-xs font-medium text-neutralGray2 text-center">Students</span>
          </div>
          <div className="flex flex-col items-center px-1 text-center">
            <span className="text-sm font-medium">
              {getAttendacePercentage(
                totalSessions.filter((i) => i.attendance && i.attendance.student === 'present').length,
                totalSessions.length
              )}%
            </span>
            <span className="text-xs font-medium text-neutralGray2 text-center">Attendance</span>
          </div>
          <div className="flex flex-col items-center px-1 text-center">
            <span className="text-sm font-medium">
              {tutor.experience.data.filter(i => i.type === "online").length}
            </span>
            <span className="text-xs font-medium text-neutralGray2">Online Exp.</span>
          </div>
          <div className="flex flex-col items-center px-1 text-center">
            {tutor.experience.data.filter(i => i.type === "offline").length}
            <span className="text-xs font-medium text-neutralGray2">Offline Exp.</span>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col gap-4">
        <ul className="w-full list-disc ml-4 flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <p className="text-sm">{personal.bio}</p>
          </div>
          <li className="text-sm">
            <div className="flex flex-col gap-2">
              <p className="text-sm font-medium">Languages Spoken</p>
              <div className="flex flex-wrap">
                {personal.languagesSpoken.map((l: any) => (
                  <p key={l} className="text-sm">
                    {l},
                  </p>
                ))}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}


function NewPersonal({personal,agreement,tutor}:{personal: ITutorPersonal, agreement: ITutorAgreement | undefined, tutor:ITutor}){
   const [studentsCount, setStudentsCount] = useState(0);
   const [totalSessions, setTotalSessions] = useState<ITrialClass[]>([]);
    const navigate = useNavigate();
     useEffect(() => {
    if (tutor) {
      xhr({
        url: `/t/${tutor._id}/stats/students-count`,
        method: "GET"
      }).then(res => setStudentsCount(res.data.count || 0))
        .catch(err => err)
    }
  }, [tutor]);

  // Total Sessions
  useEffect(() => {
    if (tutor?._id) {
      xhr({
        url: `/t/${tutor?._id}/sessions`,
        method: 'GET',
        params: {
          type: 'plan',
          status: 'completed'
        }
      })
        .then((res) => {
          if (res.status === 'OK') {
            setTotalSessions(res.data);
          }
        })
        .catch(() => { });
    }
  }, [tutor]);
  return(
    <>
    
    <div className='mb-6 lg:px-0 px-4'>
             <div className="flex justify-end">
          {agreement?.level === 'premium' ? (
            <Tooltip title="Premium Tutor" arrow>
              <img src={PRO} alt="Pro badge" className="h-7 w-7" />
            </Tooltip>
          ) : (
            <div className="h-7 w-7" />
          )}
        </div>
    
      
        <div className='lg:flex gap-5 '>
             <div className=' border-2 boder-black p-1 w-36 h-36'>
                    <img
              src={personal?.profilePic === '' ? DEFAULT_PROFILE_PIC : personal?.profilePic}
              alt="profile pic"
              className="w-32 h-32 object-cover rounded-full"
            />
             </div>

             <div className='lg:max-w-[calc(100%-10rem)]'>
                 <h1 className="underline text-[1.7rem] font-bold  capitalize py-2 md:py-0">{personal?.name}</h1>
                 {/* <p className=' mt-2 '>Australian English speaker, experience teaching in multiple countries across the world. Easy to talk to, fun conversational style learning!</p> */}
               <div>
                   <p className='text-sm text-primary mt-3 flex gap-x-3'>
                       <span><FileCheck/></span>
                       <span>Professional Teacher</span>
                    </p>
                    <p className='mt- ml-10 text-semibold text-sm'>{personal?.bio.slice(0,60)}</p>
               </div>

               <div className='mt-3'>
                        <p className='text-sm text-primary  flex gap-x-3'>
                       <span><GraduationCap /></span>
                       <span>Teacher</span>
                    </p>
        
                  
                  <div className="w-full flex flex-col gap-2 bg-white mt-2  rounded">
                  {tutor.profession.data.categoryType === 'subject' &&
                 tutor.profession.data.categories.map((cate: any, i: any) => <SubjectItem subject={cate} key={i} />)}
                {tutor.profession.data.categoryType === 'hobby' &&
                  tutor.profession.data.categories.map((cate: any, i: any) => <HobbyItem hobby={cate} key={i} />)}
               {tutor.profession.data.categoryType === 'skill' &&
                  tutor.profession.data.categories.map((cate: any, i: any) => <SkillItem skill={cate} key={i} />)}
              </div>
               {tutor?.video?.status === 'complete' && (
                <div className="bg-white p-4 rounded-md flex flex-col items-center">
                  <span className="text-2xl font-medium text-black py-2">Intro Video</span>
                 <div className="w-full h-full px-4 py-2">
                    <iframe className="w-full h-[480px]" src={tutor.video.link}></iframe>
                  </div>
             </div>
           )}
                   
               </div>

               <div className='mt-8'>
                   <h2 className='text-2xl font-bold'>About Me</h2>
                   <p className='pt-1.5'>
                    {personal?.bio}
                    </p>
               </div>
                    <div className='mt-8'>
                     <h3 className='text-2xl font-bold'>I Speak</h3>
                        <div className="flex gap-2 flex-wrap pt-1.5">
                {personal.languagesSpoken.map((l: any) => (
                  <p key={l} className="text-sm py-1 px-3 border-2 rounded-full bg-[#F5F7FF]">
                    {l}
                  </p>
                ))}
              </div>
               </div>
                      <div className="w-full flex flex-col gap-7 mt-8 ">
                 <Education education={tutor.education.data} />
              </div>

                <div className='mt-8'>
                     <h3 className='text-2xl font-bold'>Achievement & Awards</h3>
                        <div className="flex gap-1.5 flex-wrap pt-1.5">
      
                  <p className="text-sm pl-1 line-clamp-2">
                    {personal?.bio}
                  </p>
           
              </div>
               </div>

                     <div className='mt-8'>
                     <h3 className='text-2xl font-bold'>Teaching tools I love</h3>
                        <div className="flex gap-1.5 flex-wrap pt-1.5">     
                
                      <p className="text-sm pl-1 line-clamp-2">
                      Interactive whiteboards, digital textbooks, educational apps, and video conferencing tools
                      
                  </p>
           
              </div>
               </div>

                   <div className='mt-8'>
                     <h3 className='text-2xl font-bold'>Teaching Style & Philosophy</h3>
                        <div className="flex gap-1.5 flex-wrap pt-1.5">   
                
                  <p className="text-sm pl-1 line-clamp-2 ">
                    I believe in creating a supportive and engaging learning environment where students feel comfortable to explore and grow. My teaching style is student-centered, focusing on individual learning needs and adapting my approach to match each student's unique pace and style. I incorporate interactive activities, real-world examples, and technology to make learning both effective and enjoyable. My philosophy is that education should be a journey of discovery, not just a destination of memorization.
         
                  </p>
           
              </div>
               </div>
               
            <div className="w-full flex flex-col gap-7 mt-8 ">
              <Experience experience={tutor.experience.data} />
                  <div className='flex justify-between px-2 py-4'>
                             
                               </div>
              </div>
               

          

             </div>
        </div>
        <div className='flex justify-center mt-2 capitalize'>
          <Button text="Book a Free Trial" type="primary" className="mt-8 mb-10" onClick={() => {navigate('/booktrail')}} />
        </div>
    </div>
</>
  )
}

function PersonalTutProfile({ personal, tutor ,agreement}: { personal: ITutorPersonal, tutor: ITutor ,agreement:ITutorAgreement | undefined}) {
    const navigate = useNavigate();

    return (
        <div>
            {/* Header Section */}
            <div className="bg-primary text-white p-8 md:py-16 relative">
              <div className="container mx-auto flex flex-col md:flex-row items-center gap-8">
                {/* Profile Picture and Premium Badge */}
                <div className="relative w-36 h-36 md:w-40 md:h-40 flex-shrink-0">
                  <img
                    src={personal?.profilePic === '' ? DEFAULT_PROFILE_PIC : personal?.profilePic}
                    alt={personal?.name}
                    className="w-full max-h-full rounded-full border-4 border-white shadow-lg"
                  />
                  {agreement?.level === 'premium' && (
                    <Tooltip title="Premium Tutor" arrow>
                      <img src={PRO} alt="Pro badge" className="absolute -top-2 -right-2 h-10 w-10" />
                    </Tooltip>
                  )}
                </div>

                {/* Tutor Info */}
                <div className='flex flex-col items-center md:items-start text-center md:text-left flex-grow'>
                  <h1 className="text-4xl md:text-5xl font-extrabold capitalize mb-2">
                    {/* {personal?.name} */}
                    {FormatedName(personal?.name)}
                  </h1>

                  {/* Profession Categories */}
                  <div className='flex gap-2 flex-wrap mb-4 mt-2 justify-center md:justify-start'>
                    {tutor.profession.data.categories.map((cate: any, i: any) => (
                      <span key={i} className='bg-white bg-opacity-20 text-white text-sm py-1.5 px-4 rounded-lg font-medium'>
                        {cate.name}
                      </span>
                    ))}
                  </div>

                           
                  {/* Book Trial Button */}
                  {/* <button
                    onClick={() => navigate('/booktrail')}
                    className="mt-3 bg-secondary hover:bg-orange-600 text-white font-semibold py-3 px-8 rounded-lg shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105"
                  >
                    Book a Free Trial
                  </button> */}
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="">
                <div className=" mx-auto py-4 mt-4 md:py-8 space-y-6 relative" style={{top: '-2rem'}}>
                    {/* About Me */}
                    <ProfileSection title="About Me">
                        {/* <div className="mb-6 shadow-lg bg-gray-50 border-l-4 border-primary p-4 rounded-lg">
                        <h3 className="text-xl font-semibold mb-2 flex items-center gap-2">
                          <span role="img" aria-label="world map">🌍</span> Students from Around the World
                        </h3>
                        <p className="text-gray-600 mb-4">I've had the pleasure of teaching students from various countries, bringing a rich diversity of perspectives to my virtual classroom. My global student base helps create an engaging and culturally aware learning environment.</p>
                        <div className="flex flex-wrap gap-4">
                          <div className="flex items-center gap-2">
                          <span className="text-3xl" role="img" aria-label="USA flag"><US title="United States" className="h-8 w-7"/></span>
                          <span className="text-base">United States</span>
                          </div>
                          <div className="flex items-center gap-2">
                          <span className="text-3xl" role="img" aria-label="Canada flag"><CA title="Canada" className="h-8 w-7"/></span>
                          <span className="text-base">Canada</span>
                          </div>
                          <div className="flex items-center gap-2">
                          <span className="text-3xl" role="img" aria-label="UK flag"><GB title="United Kingdom" className="h-8 w-7"/></span>
                          <span className="text-base">United Kingdom</span>
                          </div>
                          <div className="flex items-center gap-2">
                          <span className="text-3xl" role="img" aria-label="India flag"><IN title="India" className="h-8 w-7"/></span>
                          <span className="text-base">India</span>
                          </div>
                          <div className="flex items-center gap-2">
                          <span className="text-3xl" role="img" aria-label="Australia flag"><AU title="Australia" className="h-8 w-7"/> </span>
                          <span className="text-base">Australia</span>
                          </div>
                          <div className="flex items-center gap-2">
                          <span className="text-3xl" role="img" aria-label="Germany flag"><DE title="Germany" className="h-8 w-7"/> </span>
                          <span className="text-base">Germany</span>
                          </div>
                          <div className="flex items-center gap-2">
                          <span className="text-3xl" role="img" aria-label="France flag"><FR title="France" className="h-8 w-7"/> </span>
                          <span className="text-base">France</span>
                          </div>
                        
                        </div>
                        </div> */}
                        <p className='shadow-lg bg-gray-50 border-l-4 border-secondary p-4 rounded-lg'>{personal?.bio}</p>
                    </ProfileSection>

                 

                    {/* Education */}
                    <ProfileSection title="Education">
                        {tutor.education.data.map((edu, i) => (
                            <div key={i} className="flex flex-col gap-4 p-6 mb-4 shadow-md bg-gray-50 rounded-lg border-l-4 even:border-secondary odd:border-primary">
                              <div className="flex items-center gap-2">
                              <GraduationCap className="text-primary" size={20} />
                              <h3 className="text-lg font-semibold text-gray-800">{edu.degree}, {edu.course} {edu.specialisation}</h3>
                              </div>
                              <div className="ml-7">
                              <p className="text-gray-700 font-medium">{edu.university}</p>
                              <p className="text-gray-600 text-sm">{edu.year}</p>
                              </div>
                            </div>
                        ))}
                    </ProfileSection>
                   
                         {/*Teacher  */}
                    <ProfileSection title="Teacher">
                       {/* <p>{personal?.bio}</p> */}
                       
               <div className='mt-3'>
                           
                  
                  <div className="w-full flex flex-col gap-2  mt-2  shadow-lg bg-gray-50 border-l-4 border-secondary p-4 rounded-lg">
                  {tutor.profession.data.categoryType === 'subject' &&
                 tutor.profession.data.categories.map((cate: any, i: any) => <SubjectItem subject={cate} key={i} />)}
                {tutor.profession.data.categoryType === 'hobby' &&
                  tutor.profession.data.categories.map((cate: any, i: any) => <HobbyItem hobby={cate} key={i} />)}
               {tutor.profession.data.categoryType === 'skill' &&
                  tutor.profession.data.categories.map((cate: any, i: any) => <SkillItem skill={cate} key={i} />)}
              </div>
               {tutor?.video?.status === 'complete' && (
                <div className="bg-white p-4 rounded-md flex flex-col items-center">
                  <span className="text-2xl font-medium text-black py-2">Intro Video</span>
                 <div className="w-full h-full px-4 py-2">
                    <iframe className="w-full h-[480px]" src={tutor.video.link}></iframe>
                  </div>
             </div>
           )}
                   
               </div>
                    </ProfileSection>

                    {/* Achievement & Awards */}

                    <ProfileSection title='Achievement & Awards'>
                        <div className="flex flex-col gap-4">
                        <div className="flex items-center gap-3 p-4 shadow-lg bg-gray-50 border-l-4 border-secondary rounded-lg">
                        <span role="img" aria-label="chart increasing" className="text-2xl">📈</span>
                        <p className="text-gray-700 text-lg font-medium">90% retainment Rate </p>
                        </div>
                        <div className="flex items-center gap-3 p-4 shadow-lg bg-gray-50 border-l-4 border-primary rounded-lg">
                        <span role="img" aria-label="speech bubble" className="text-2xl">💬</span>
                        <p className="text-gray-700 text-lg font-medium">Positive Parent Review</p>
                        </div>
                        <div className="flex items-center gap-3 p-4 shadow-lg bg-gray-50 border-l-4 border-secondary rounded-lg">
                        <span role="img" aria-label="certificate" className="text-2xl">🏅</span>
                        <p className="text-gray-700 text-lg font-medium">Certified Advanced ESL Instructor</p>
                        </div>
                        <div className="flex items-center gap-3 p-4 shadow-lg bg-gray-50 border-l-4 border-primary rounded-lg">
                        <span role="img" aria-label="star" className="text-2xl">🌟</span>
                        <p className="text-gray-700 text-lg font-medium">Digital Techo Teachers At WORLDO</p>
                        </div>                   
                      
                    </div>
                    </ProfileSection>

              

                    {/* Teaching Tools I Love */}
                    <ProfileSection title="Teaching Tools I Love">
                      <div className="flex flex-wrap gap-4 shadow-lg bg-gray-50 border-l-4 border-primary p-4 rounded-lg">
                        <div className="flex flex-col  justify-center p-4 bg-[#F5F7FF] border border-blue-200 rounded-xl text-blue-700 items-center min-w-[250px]">
                          <span className="text-lg font-medium"> 📊 Interactive</span>
                          <span className="text-lg font-medium">Whiteboards</span>
                        </div>
                        <div className="flex flex-col  justify-center p-4 bg-[#F5F7FF] border border-blue-200 rounded-xl text-blue-700 items-center min-w-[250px]">
                          <span className="text-lg font-medium">📚 Digital</span>
                          <span className="text-lg font-medium">Textbooks</span>
                        </div>
                        <div className="flex flex-col  justify-center p-4 bg-[#F5F7FF] border border-blue-200 rounded-xl text-blue-700 items-center min-w-[250px]">
                          <span className="text-lg font-medium">🎮 Educational</span>
                          <span className="text-lg font-medium">Apps</span>
                        </div>
                        <div className="flex flex-col  justify-center p-4 bg-[#F5F7FF] border border-blue-200 rounded-xl text-blue-700 items-center min-w-[250px]">
                          <span className="text-lg font-medium">📹 Video</span>
                          <span className="text-lg font-medium">Conferencing</span>
                        </div>
                      </div>
                    </ProfileSection>

                    {/* Teaching Style & Philosophy */}
                
                    <ProfileSection title="Teaching Style & Philosophy">
                      <p className="mb-4 shadow-lg bg-gray-50 border-l-4 border-secondary p-4 rounded-lg">
                      I believe in fostering a dynamic and supportive learning environment where students are encouraged to actively participate and explore. My teaching methodology is student-centered, adapting to diverse learning styles and paces. I integrate interactive activities, real-world applications, and modern educational technology to make learning both effective and enjoyable. My core philosophy is that education is a transformative journey of discovery, empowering students to develop a lifelong love for learning and critical thinking skills.
                      </p>
                      <div className="flex flex-wrap gap-4 shadow-lg bg-gray-50 border-l-4 border-primary p-4 rounded-lg">
                      <div className="flex items-center gap-2 p-3 bg-[#F5F7FF] border border-blue-200 rounded-xl text-blue-700">
                      <span className="text-xl">🎯</span>
                      <span className="font-medium">Individualized Learning</span>
                      </div>
               
                      </div>
                    </ProfileSection>
   {/* Languages I Speak */}
                    <ProfileSection title="Languages I Speak">
                        <div className="flex flex-wrap gap-2">
                            {personal?.languagesSpoken.map((lang, i) => (
                                <p key={i} className=" border   px-4 py-1.5   shadow-lg bg-gray-50 border-l-4 even:border-secondary odd:border-primary p-4 rounded-lg ">{lang}</p>
                            ))}
                        </div>
                    </ProfileSection>
                    {/* Experience */}
                    <ProfileSection title="Experience">
                          <div className="mb-6 shadow-lg bg-gray-50 border-l-4 border-secondary p-4 rounded-lg">
                            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
                            <span role="img" aria-label="experience">✨</span> Teaching Experience
                            </h3>
                            <div className="flex flex-wrap gap-4">
                            <div className="flex items-center gap-2 p-3 bg-[#F5F7FF] border border-blue-200 rounded-xl text-blue-700">
                              <Laptop size={20} />
                              <span className="font-medium">Online: {tutor.experience.data.filter(i => i.type === "online").length} years</span>
                            </div>
                            <div className="flex items-center gap-2 p-3 bg-[#F5F7FF] border border-blue-200 rounded-xl text-blue-700">
                              <Presentation size={20} />
                              <span className="font-medium">Offline: {tutor.experience.data.filter(i => i.type === "offline").length} years</span>
                            </div>
                            </div>
                          </div>
                        {tutor.experience.data.map((exp, i) => (
                          <div key={i} className={`flex flex-col gap-4 p-6 mb-4 bg-white rounded-lg shadow-lg border-l-4 ${i % 2 === 0 ? 'border-primary' : 'border-secondary'}`}>
                          <div className="flex items-center gap-4">
                            {exp.type === 'online' ? (
                            <Laptop className={`${i % 2 === 0 ? 'text-primary' : 'text-secondary'} flex-shrink-0`} size={32} />
                            ) : (
                            <Presentation className={`${i % 2 === 0 ? 'text-primary' : 'text-secondary'} flex-shrink-0`} size={32} />
                            )}
                            <div className="flex flex-col">
                            <h3 className="text-xl font-semibold text-gray-900">{exp.organization}</h3>
                            <span className={`text-sm font-medium px-3 py-1 rounded-full w-max ${i % 2 === 0 ? 'bg-blue-100 text-blue-700' : 'bg-orange-100 text-orange-700'} mt-1 capitalize`}>
                              {exp.type}
                            </span>
                            </div>
                          </div>
                          <div className="ml-12 flex flex-col gap-2">
                            <div className="flex items-center gap-2 text-gray-700">
                            <FileCheck className="text-gray-500" size={18} />
                            <p className="text-base">
                              {exp.workingSince.start.month}/{exp.workingSince.start.year} - {exp.workingSince.end ? `${exp.workingSince.end.month}/${exp.workingSince.end.year}` : 'Present'}
                            </p>
                            </div>
                        
                          </div>
                          </div>
                        ))}
                    </ProfileSection>

                    {/* Final CTA */}
                    <div className="text-center pt-6">
                        <button
                            onClick={() => navigate('/booktrail')}
                            className="bg-secondary hover:bg-orange-600 text-white font-semibold py-3 px-8 rounded-lg text-lg"
                        >
                            Book a Free Trial
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function ProfileSection({ title, children }: { title: string, children: React.ReactNode }) {
    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">{title}</h2>
            <div className="text-gray-700">
                {children}
            </div>
        </div>
    );
}

export function SubjectItem({ subject }: { subject: ITutorProfessionCategory<IProfessionSubject> }) {
  const [expand, setExpand] = useState(false);
  return (
    <div
      onClick={() => setExpand(!expand)}
      className="w-full flex flex-col gap-4 p-4 bg-white rounded-xl  border border-gray-100 cursor-pointer transition-all duration-300 ease-in-out hover:shadow-xl hover:border-primary"
    >
      <div className="w-full flex items-center justify-between">
      <h1 className="text-lg font-semibold text-gray-900">{subject.name}</h1>
      <MdKeyboardArrowDown className={`text-2xl text-gray-500 ${expand ? "rotate-180" : "rotate-0"} transition-all duration-300`} />
      </div>
      {expand && (
      <div className="w-full grid lg:grid-cols-2 grid-cols-1 gap-6 mt-4 pt-4 border-t border-gray-100">
        {subject.board.map((item, index: any) => (
        <div className="bg-blue-50 rounded-lg shadow-md p-6 border-l-4 even:border-secondary odd:border-primary flex flex-col gap-4" key={index}>
          <div className="flex items-center gap-3">
          <BookOpen className="text-primary" size={24} />
          <h3 className="text-lg font-bold text-gray-800">Board: {item.name}</h3>
          </div>
          <div className="ml-9 flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <GraduationCap className="text-gray-600" size={20} />
            <p className="text-base font-semibold text-gray-700">Grades:</p>
            <div className="flex flex-wrap gap-2">
            {item.grades.length > 0 ? (
              item.grades.map((i, idx: any) => (
              <span className="text-gray-700 text-sm font-medium bg-blue-100 px-3 py-1 rounded-full" key={idx}>
                {i}
              </span>
              ))
            ) : (
              <span className="text-gray-500 text-sm">N/A</span>
            )}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Award className="text-gray-600" size={20} />
            <p className="text-base font-semibold text-gray-700">Experience:</p>
            <p className="text-gray-700 text-sm font-medium">{item.experience} years</p>
          </div>
          <div className="flex items-center gap-2">
            <Star className="text-gray-600" size={20} />
            <p className="text-base font-semibold text-gray-700">Speciality:</p>
            <div className="flex flex-wrap gap-2 capitalize">
            {item.strengths.length > 0 ? (
              item.strengths.map((i, idx: any) => (
              <span className="text-gray-700 text-sm font-medium bg-green-100 px-3 py-1 rounded-full" key={idx}>
                {i}
              </span>
              ))
            ) : (
              <span className="text-gray-500 text-sm">None</span>
            )}
            </div>
          </div>
          </div>
        </div>
        ))}
      </div>
      )}
    </div>
  );
}

export function HobbyItem({ hobby }: { hobby: ITutorProfessionCategory<IProfessionHobby> }) {
  const [expand, setExpand] = useState(false);
  return (
    <div
      onClick={() => setExpand(!expand)}
      className="w-full flex flex-col gap-4 p-4 bg-neutralBlue2 rounded-md cursor-pointer"
    >
      <div className="w-full flex items-center justify-between">
        <h1 className="text-base font-semibold">{hobby.name}</h1>
        <MdKeyboardArrowDown className={`text-base ${expand ? "rotate-180" : "rotate-0"} transition-all`} />
      </div>
      {expand && (
        <div className="w-full grid lg:grid-cols-2 grid-cols-1 gap-4">
          {hobby?.types && hobby?.types?.length > 0 ? (
            <>
              {hobby.types?.map((item, index: any) => (
                <div className="bg-white rounded-xl flex flex-col gap-4 p-4 drop-shadow-lg" key={index}>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Type:</h3>
                    <p className="text-neutralGray2">{item.name}</p>
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Levels:</h3>
                    <div className="flex flex-wrap">
                      {item.levels.length > 0 &&
                        item.levels.map((i, index: any) => (
                          <p className="text-neutralGray2" key={index}>
                            {index ? ', ' : ''}
                            {i}
                          </p>
                        ))}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Years of Experience:</h3>
                    <p className="text-neutralGray2">
                      {item.experience}
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Speciality:</h3>
                    <div className="flex flex-wrap">
                      {item.strengths.length > 0 &&
                        item.strengths.map((i, index: any) => (
                          <p className="text-neutralGray2" key={index}>
                            {index ? ', ' : ''}
                            {i}
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="bg-white rounded-xl flex flex-col gap-4 p-4 drop-shadow-lg">
              <div className="flex flex-col">
                <h3 className="text-base font-medium">Levels:</h3>
                <div className="flex flex-wrap">
                  {hobby.levels && hobby.levels.length > 0 &&
                    hobby.levels.map((i, index: any) => (
                      <p className="text-neutralGray2" key={index}>
                        {index ? ', ' : ''}
                        {i}
                      </p>
                    ))}
                </div>
              </div>
              <div className="flex flex-col">
                <h3 className="text-base font-medium">Years of Experience:</h3>
                <p className="text-neutralGray2">
                  {hobby.experience}
                </p>
              </div>
              <div className="flex flex-col">
                <h3 className="text-base font-medium">Speciality:</h3>
                <div className="flex flex-wrap">
                  {hobby.strengths && hobby.strengths.length > 0 &&
                    hobby.strengths.map((i, index: any) => (
                      <p className="text-neutralGray2" key={index}>
                        {index ? ', ' : ''}
                        {i}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function SkillItem({ skill }: { skill: ITutorProfessionCategory<IProfessionSkill> }) {
  const [expand, setExpand] = useState(false);
  return (
    <div
      onClick={() => setExpand(!expand)}
      className="w-full flex flex-col gap-1.5 p-4 bg-neutralBlue2 rounded-md cursor-pointer"
    >
      <div className="w-full flex items-center justify-between">
        <h1 className="text-base font-semibold">{skill.name}</h1>
        <MdKeyboardArrowDown className={`text-base ${expand ? "rotate-180" : "rotate-0"} transition-all`} />
      </div>
      {expand && (
        <div className="w-full grid lg:grid-cols-2 grid-cols-1 gap-4">
          {skill?.types && skill?.types?.length > 0 ? (
            <>
              {skill.types?.map((item, index: any) => (
                <div className="bg-white rounded-xl flex flex-col gap-4 p-4 drop-shadow-lg" key={index}>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Type:</h3>
                    <p className="text-neutralGray2">{item.name}</p>
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Levels:</h3>
                    <div className="flex flex-wrap">
                      {item.levels.length > 0 &&
                        item.levels.map((i, index: any) => (
                          <p className="text-neutralGray2" key={index}>
                            {index ? ', ' : ''}
                            {i}
                          </p>
                        ))}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Years of Experience:</h3>
                    <p className="text-neutralGray2">
                      {item.experience}
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-base font-medium">Speciality:</h3>
                    <div className="flex flex-wrap">
                      {item.strengths.length > 0 &&
                        item.strengths.map((i, index: any) => (
                          <p className="text-neutralGray2" key={index}>
                            {index ? ', ' : ''}
                            {i}
                          </p>
                        ))}
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="bg-white rounded-xl flex flex-col gap-4 p-4 drop-shadow-lg">
              <div className="flex flex-col">
                <h3 className="text-base font-medium">Levels:</h3>
                <div className="flex flex-wrap">
                  {skill.levels &&
                    skill.levels.length > 0 &&
                    skill.levels.map((i, index: any) => (
                      <p className="text-neutralGray2" key={index}>
                        {index ? ', ' : ''}
                        {i}
                      </p>
                    ))}
                </div>
              </div>
              <div className="flex flex-col">
                <h3 className="text-base font-medium">Years of Experience:</h3>
                <p className="text-neutralGray2">
                  {skill.experience}
                </p>
              </div>
              <div className="flex flex-col">
                <h3 className="text-base font-medium">Speciality:</h3>
                <div className="flex flex-wrap">
                  {skill.strengths &&
                    skill.strengths.length > 0 &&
                    skill.strengths.map((i, index: any) => (
                      <p className="text-neutralGray2" key={index}>
                        {index ? ', ' : ''}
                        {i}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function Education({ education }: any) {
  return (
    <>
      <div className="w-full flex flex-col gap-1.5">
        <h1 className="text-2xl font-semibold">Education</h1>
        <ul className="w-full list-none ml-1 flex flex-col gap-4">
          {education.map((edu: any, i: any) => (
            <li className="text-sm " key={i}>
              {edu.degree}, {edu.course} {edu.specialisation}, {edu.university}, {edu.year}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

function Experience({ experience }: any) {
  return (
    <>
      <div className="w-full flex flex-col gap-1.5">
        <h1 className="text-2xl font-semibold">Experience</h1>
        <ul className="w-full list-disc ml-1 flex flex-col gap-4">
          {experience.map((exp: any, i: any) => (
            <li className="text-sm list-none" key={i}>
              <div className="flex flex-col gap-2 text-sm">
                <p><span>Organization : </span>{exp.organization}</p>
                <p><span>Mode : </span>{exp.type}</p>
                <p>
                  <span>Duration : </span>
                  {exp.workingSince.start.month}/{exp.workingSince.start.year} to 
                  {experience.workingSince && experience.workingSince.end ?
                    experience.workingSince.end.month + "/" + experience.workingSince.end.year
                    :
                    " currently working"
                  }
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}


const FormatedName = (name:string) => {
    const nameParts = name.split(' ');
    const firstInitial = nameParts[0] ? nameParts[0].charAt(0) : '';
    const lastName = nameParts.length > 1 ? nameParts[nameParts.length-1] : '';
    const formattedName = `${firstInitial}. ${lastName}`;
  return formattedName;
}
